import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const SCROLL_KEY = "lov:scrollPositions";

type Map = Record<string, number>;

const read = (): Map => {
  try {
    return JSON.parse(sessionStorage.getItem(SCROLL_KEY) || "{}");
  } catch {
    return {};
  }
};

const write = (m: Map) => {
  try {
    sessionStorage.setItem(SCROLL_KEY, JSON.stringify(m));
  } catch {
    /* noop */
  }
};

/**
 * Restores scroll position when navigating back (POP), saves on every other navigation.
 * Pair this with RouteScrollToTop disabled OR let it co-exist (RouteScrollToTop already scrolls to top on push).
 */
export function useScrollRestore() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const key = location.pathname + location.search;
    if (navType === "POP") {
      const map = read();
      const y = map[key];
      if (typeof y === "number") {
        // wait for DOM paint
        requestAnimationFrame(() => window.scrollTo(0, y));
      }
    }
    const onBeforeUnload = () => {
      const map = read();
      map[key] = window.scrollY;
      write(map);
    };
    const saveNow = () => {
      const map = read();
      map[key] = window.scrollY;
      write(map);
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      saveNow();
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [location.pathname, location.search, navType]);
}
